import { render, staticRenderFns } from "./new-post-page.vue?vue&type=template&id=3386b052"
import script from "./new-post-page.vue?vue&type=script&lang=js"
export * from "./new-post-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports